import { apiClient } from '@core/api/ApiClientFactory';
import type { OperationModesScheduleGroup } from '@features/shopautomation/types.ts';
import { v4 as uuidv4 } from 'uuid';

export interface ShopAutomationModule {
    id: string;
    moduleId: string;
    operationModesSchedules: OperationModesScheduleGroup[];
    activeOperationModes: string[];
    hasDisabledOperationModeSchedules: boolean;
    [key: string]: any;
}

function withPlaceholders(schedules: OperationModesScheduleGroup[]): OperationModesScheduleGroup[] {
    if (!schedules.some((s) => !s.placeholderId)) return schedules;
    return schedules.map((s) => ({ ...s, placeholderId: s.placeholderId || uuidv4() }));
}

export const operationModesSchedulesService = {
    async loadAll(shopId: string): Promise<{
        schedules: OperationModesScheduleGroup[];
        activeOperationModes: string[];
        module: ShopAutomationModule | null;
    }> {
        try {
            const shopAutomationResponse = await apiClient.get<ShopAutomationModule[]>(`shopAutomation/${shopId}`);
            const modules: ShopAutomationModule[] = shopAutomationResponse.data || [];
            const module = modules[0] ?? null;

            return {
                schedules: withPlaceholders(module?.operationModesSchedules || []),
                activeOperationModes: module?.activeOperationModes || [],
                module
            };
        } catch (error) {
            console.error('[OperationModesSchedulesService] Error loading schedules:', error);
            throw error;
        }
    },

    async save(module: ShopAutomationModule, schedules: OperationModesScheduleGroup[]): Promise<void> {
        try {
            await apiClient.put(`shopautomation/${module.id}`, { ...module, operationModesSchedules: schedules });
        } catch (error) {
            console.error('[OperationModesSchedulesService] Error saving schedules:', error);
            throw error;
        }
    }
};
